import dayjs from 'dayjs';
import type { RequestEvent } from '../components/General/PlayerChart/types';
import type {
	ReplayInteractiveData,
	DateInput,
} from '../pages/InteractiveSimulation/types/replayInteractive';
import type { MeasurementInfrastructure } from '../domain/InteractiveSimulations/MeasurementInfrastructure';

function dateInputToTimestamp(dateInput: DateInput): number {
	if (typeof dateInput === 'number') {
		return dateInput;
	}

	if (typeof dateInput === 'string') {
		const timestamp = dayjs.utc(dateInput).valueOf();
		return timestamp;
	}

	if (dateInput instanceof Date) {
		const localTimeString = dayjs(dateInput).format('YYYY-MM-DD HH:mm:ss');
		const timestamp = dayjs.utc(localTimeString).valueOf();
		return timestamp;
	}

	const localTimeString = dateInput.format('YYYY-MM-DD HH:mm:ss');
	const timestamp = dayjs.utc(localTimeString).valueOf();
	return timestamp;
}

export function transformReplayDataToRequestEvents(
	replayData: ReplayInteractiveData[],
	infrastructures: MeasurementInfrastructure[],
): RequestEvent[] {
	return replayData
		.filter((timePoint) => timePoint.requestData && timePoint.requestData.length > 0)
		.map((timePoint) => ({
			timestamp: dateInputToTimestamp(timePoint.time),
			timeEvent: timePoint.timeEvent,
			requestData: timePoint.requestData.map((request) => {
				const infrastructure = infrastructures.find(
					(infra) => infra.measurementeInfraestructureId === request.infrastructureId
				);
				return {
					infrastructureId: request.infrastructureId,
					mod_value: request.mod_value,
					nameInfrastructure: infrastructure?.measurementInfraestructureName || `Infrastructure ${request.infrastructureId}`,
				};
			}),
		}));
}